var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"button",class:_vm.classes,attrs:{"to":_vm.route,"href":_vm.href,"type":_vm.htmlType},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('UIIcon',{attrs:{"type":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }